export class ChartConfig {
  chartTitle?: string;
  type: ChartTypeEnum;
  options?: ChartOptions;
  chartLegend?: boolean;
  constructor(init?: ChartConfig) {
    Object.assign(this, init);
  }
};

export class ChartOptions {
  responsive?: boolean;
  scaleShowVerticalLines?: boolean;
  scales?: {};
  tooltips?: {};
  constructor(init?: ChartOptions) {
    Object.assign(this, init);
  }
};

export class BasicChartData {
  labels: string[];
  dataSet: ChartDataSet;
  config: ChartConfig;
  constructor(init?: BasicChartData) {
    Object.assign(this, init);
  }
}

export enum OrderChartValueTypeEnum {
  byValue = 1,
  byQty = 2
}

export class ChartDataSet {
  label: string;
  data: number[];
  borderColor?: ChartColorEnum[] | ChartColorEnum | string[] | string;
  backgroundColor?: ChartColorEnum[] | ChartColorEnum | string[] | string;
  borderWidth?: number;
  borderRadius?: number;
  minBarWidth?: number;
  maxBarThickness?: number;
  hoverBackgroundColor?: ChartColorEnum[] | ChartColorEnum | string[] | string;
  hoverBorderColor?: ChartColorEnum[] | ChartColorEnum | string[] | string;
  barPercentage?: number;
  barThickness?: number;
  minBarLength?: number;
  constructor(init?: ChartDataSet) {
    Object.assign(this, init);
  }
}

export enum ChartTypeEnum {
  bar = 'bar',
  pie = 'pie',
  // line = 'line',
  // doughnut = 'doughnut',
  // polarArea = 'polarArea',
  // radar = 'radar',
}

export enum ChartColorEnum {
  redSolid = 'rgb(255, 99, 132)',
  orangeSolid = 'rgb(255, 159, 64)',
  yellowSolid = 'rgb(255, 205, 86)',
  greenSolid = 'rgb(75, 192, 192)',
  blueSolid = 'rgb(54, 162, 235)',
  purpleSolid = 'rgb(153, 102, 255)',
  greySolid = 'rgb(201, 203, 207)',
  redSolidHover = 'rgba(255, 41, 86, 1)',
  orangeSolidHover = 'rgba(255, 138, 20, 1)',
  yellowSolidHover = 'rgba(255, 189, 36, 1)',
  greenSolidHover = 'rgba(29, 191, 191, 1)',
  blueSolidHover = 'rgba(22, 140, 219, 1)',
  purpleSolidHover = 'rgba(112, 41, 255, 1)',
  greySolidHover = 'rgba(174, 185, 207, 1)',
  redAlpha = 'rgb(255, 99, 132, 0.5)',
  orangeAlpha = 'rgb(255, 159, 64,0.5)',
  yellowAlpha = 'rgb(255, 205, 86,0.5)',
  greenAlpha = 'rgb(75, 192, 192,0.5)',
  blueAlpha = 'rgb(54, 162, 235,0.5)',
  purpleAlpha = 'rgb(153, 102, 255,0.5)',
  greyAlpha = 'rgb(201, 203, 207,0.5)',
  redAlphaHover = 'rgba(255, 41, 86, 0.5)',
  orangeAlphaHover = 'rgba(255, 138, 20, 0.5)',
  yellowAlphaHover = 'rgba(255, 189, 36, 0.5)',
  greenAlphaHover = 'rgba(29, 191, 191, 0.5)',
  blueAlphaHover = 'rgba(22, 140, 219, 0.5)',
  purpleAlphaHover = 'rgba(112, 41, 255, 0.5)',
  greyAlphaHover = 'rgba(174, 185, 207, 0.5)',
};


export enum MonthListEnum {
  'January' = 1,
  'February' = 2,
  'March' = 3,
  'April' = 4,
  'May' = 5,
  'June' = 6,
  'July' = 7,
  'August' = 8,
  'September' = 9,
  'October' = 10,
  'November' = 11,
  'December' = 12,
}
